"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var _LanguageProvider = require("../../common/LanguageProvider");
var useCategory = function useCategory(categoryId, fetchedCategories) {
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  return (0, _swr["default"])([categoryId, language, "useCategory"], _fetcher["default"], {
    initialData: fetchedCategories
  });
};
var _default = useCategory;
exports["default"] = _default;